import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import ApiService from "@/core/services/ApiService";
import {
  AccountsTransactionVolumeResponse,
  CompanyStatistic,
  TransactionVolume,
} from "@/core/services/api/interfaces/manager/Company";
const baseStatistics = {
  transactions: {
    all: 0,
    waiting: 0,
    approved: 0,
    denied: 0,
  },
} as CompanyStatistic;

@Module
export default class CompanyStatisticModule extends VuexModule {
  statistic = baseStatistics;

  transactionVolume: TransactionVolume[] = [];
  accountsTransactionVolume: AccountsTransactionVolumeResponse = {
    periods: [],
    accounts: [],
    account_volumes: {},
    account_details: {},
  };

  get companyStatistic(): CompanyStatistic {
    return this.statistic;
  }

  get companyStatisticTransactionVolume(): TransactionVolume[] {
    return this.transactionVolume;
  }

  get companyStatisticAccountsVolume(): AccountsTransactionVolumeResponse {
    return this.accountsTransactionVolume;
  }

  @Action({ rawError: true })
  [Actions.MANAGER_COMPANY_STATISTIC_LOAD]() {
    if (
      !this.context.getters.isIndividualOrHas2FA ||
      !this.context.getters.isUserCompanyEnabled
    ) {
      return;
    }
    return ApiService.manager.company
      .statistic()
      .then(ApiService.unwrapItemResponse)
      .then((statistic) => {
        this.context.commit(Mutations.MANAGER_COMPANY_STATISTIC_SET, statistic);

        this.context.commit(
          Mutations.COMMON_REQUEST_DONE,
          Actions.MANAGER_COMPANY_STATISTIC_LOAD
        );
      });
  }

  @Action({ rawError: true })
  [Actions.MANAGER_COMPANY_STATISTIC_TRANSACTION_VOLUME_LOAD](params?) {
    if (
      !this.context.getters.isIndividualOrHas2FA ||
      !this.context.getters.isUserCompanyEnabled
    ) {
      return;
    }

    return ApiService.manager.company
      .statisticTransactionVolume(params)
      .then(ApiService.unwrapItemResponse)
      .then((statistic) =>
        this.context.commit(
          Mutations.MANAGER_COMPANY_STATISTIC_TRANSACTION_VOLUME_SET,
          statistic as TransactionVolume[]
        )
      );
  }

  @Action({ rawError: true })
  [Actions.MANAGER_COMPANY_STATISTIC_ACCOUNTS_VOLUME_LOAD](params?) {
    if (
      !this.context.getters.isIndividualOrHas2FA ||
      !this.context.getters.isUserCompanyEnabled
    ) {
      return;
    }

    return ApiService.manager.company
      .statisticAccountVolume(params)
      .then(ApiService.unwrapItemResponse<AccountsTransactionVolumeResponse>)
      .then((statistic) =>
        this.context.commit(
          Mutations.MANAGER_COMPANY_STATISTIC_ACCOUNTS_VOLUME_SET,
          statistic
        )
      );
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_STATISTIC_SET](statistic) {
    this.statistic = statistic;
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_STATISTIC_RESET]() {
    this.statistic = baseStatistics;
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_STATISTIC_TRANSACTION_VOLUME_SET](volume) {
    this.transactionVolume = volume;
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_STATISTIC_ACCOUNTS_VOLUME_SET](
    volume: AccountsTransactionVolumeResponse
  ) {
    this.accountsTransactionVolume = volume;
  }
}
